module.exports = __webpack_public_path__ + "static/media/7.86857f75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/7.jpg
// module id = 540
// module chunks = 0